<template>
    <div>
        <v-card class="mt-3">

            <!-- <pre>{{query}}</pre> -->
            <v-card-text>
                <v-simple-table
                  fixed-header
                  width="100%"
                  height="80vh"
                >
                  <thead>
                    <tr>
                      <th class="cabecera" v-for="(c,idx) in columnas" :key="idx" :width="c.width?c.width:''">
                          {{c.nombre}}
                      </th>
                    </tr>
                    <tr>
                      <th class="text-center" v-for="(col,index) in columnas" :key="index" scope="col">

                        <!-- <v-text-field label="" v-if="col.tipo=='texto' && col.searchable" v-model="col.busqueda" @input="cargar" placeholder="Buscar..."></v-text-field> -->
                        <input v-if="col.tipo=='texto' && col.searchable" class="form-control form-control-sm" type="text" v-model="col.busqueda" @input="cargar(col)" placeholder="Buscar...">

                        <select v-if="col.tipo=='select' && col.searchable" class="form-control" v-model="col.busqueda" @change="cargar(col)">
                          <option value="">-- Sin Selección --</option>
                          <option v-for="(opc,idx_opc1) in col.opciones" :key="idx_opc1" :value="devuelve_valor(opc,col.valor_opcion)">{{devuelve_valor(opc,col.texto_opcion)}}</option>
                        </select>

                        <div class="form-group" v-if="col.tipo == 'multiselect'">
                              <select class="form-control js-example-basic-multiple" v-model="col.busqueda" multiple @change="cargar(col)">
                                  <option value="">-- Sin Selección --</option>
                                  <option v-for="(opc,idx_opc2) in col.opciones" :key="idx_opc2" :value="devuelve_valor(opc,col.valor_opcion)">{{devuelve_valor(opc,col.texto_opcion)}}</option>
                              </select>
                          </div>

                        <input v-if="col.tipo=='numero' && col.searchable" class="form-control form-control-sm" type="number" v-model="col.busqueda" @input="cargar(col)" placeholder="Buscar...">

                        <input v-if="(col.tipo=='datetime' || col.tipo == 'date')&& col.searchable" v-model="col.busqueda" @change="cargar(col)" class="form-control" type="date" value="" id="">

                        <v-autocomplete v-if="col.tipo == 'autocomplete' && col.searchable"
                          v-model="col.busqueda"
                          dense
                          :items="col.opciones"
                          :item-text="col.texto_opcion"
                          :item-value="col.valor_opcion"
                          @keyup="cargarOpciones($event,col,index)"
                          @input="cargar(col)"
                          label="buscar..."
                        ></v-autocomplete>
                      </th>

                    </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(item,idx_lista) in lista" :key="idx_lista">
                          <td class="text-center" v-for="(c,idx2) in columnas" :key="idx2">
                              <slot :name="c.key" :index="idx_lista" :item="item">
                                  <span
                                      v-if="c.tipo == 'select' || c.tipo == 'texto' || c.tipo == 'numero' || c.tipo == 'multiselect' || c.tipo == 'autocomplete'">{{
                                          devuelve_valor(item, c.path, c.tipo_dato)
                                      }}</span>
                                  <span
                                      v-if="c.tipo == 'datetime'">{{
                                          devuelve_valor(item, c.path, c.tipo_dato) | fechaCompleta
                                      }}</span>
                                  <span
                                      v-if="c.tipo == 'date'">{{
                                          devuelve_valor(item, c.path, c.tipo_dato)| formatearFecha
                                      }}</span>
                                  <span v-if="(c.tipo == 'evento') && !c.icono_ok">

                                    <!-- para botones que NO necesitan deshabilitarse -->
                                    <v-btn v-if="!c.disabled" small dark :color="c.color"
                                            @click="emitir(item,c.evento,idx_lista)">
                                      <v-icon>{{ c.icono }}</v-icon>
                                    </v-btn>

                                            <!-- para botones que SI necesitan deshabilitarse -->
                                    <v-btn v-if="c.disabled" small dark :color="c.color"
                                            @click="emitir(item,c.evento,idx_lista)"
                                            :disabled="devuelve_valor(item,c.disabled,'boolean')">
                                      <v-icon>{{ c.icono }}</v-icon>
                                    </v-btn>
                                  </span>
                                  <span v-if="(c.tipo == 'evento') && c.icono_ok">
                                    <v-btn v-if="c.disabled && !item.recibido" small dark :color="c.color"
                                            @click="emitir(item,c.evento,idx_lista)"
                                            :disabled="devuelve_valor(item,c.disabled,'boolean')">
                                      <v-icon>{{ c.icono }}</v-icon> 
                                    </v-btn>
                                    <v-icon v-if="item.recibido" dark color="primary" :title="c.icono_ok">done</v-icon>
                                  </span>
                              </slot>
                          </td>
                      </tr>
                  </tbody>
                </v-simple-table>
                <!-- <pre>{{columnas}}</pre> -->
            </v-card-text>

            <v-card-text>
              <!-- <pre>{{query}}</pre>
              <pre>{{page}}</pre>
              <pre>{{total_paginas}}</pre> -->
              <pre>{{autocomplete}}</pre>
              <v-pagination
                v-model="page"
                total-visible="10"
                :length="total_paginas"
                @input="navegar"
              ></v-pagination>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
export default {
    data:()=>({
        //items:[],
        //cabeceras:[],
        paginacion:20,
        page:1,
        autocomplete:null
    }),
    beforeDestroy() {
      Event.$off('setear_tabla');
    },
    mounted(){
        this.$parent.$on('setear_tabla',(cabeceras,items)=>{
            //this.cabeceras = cabeceras;
            //this.items = items;
            //console.log('setear_tablaaa',cabeceras,items);
        })
        //this.actualizarTablaPaginada({lista:[],columnas:[],total_paginas:0});
    },
    methods:{
        devuelve_valor(item,path,tipo_dato){
          if(path == undefined){
            return '';
          }
          let keys = path.split('.');
          let valor = item;
          keys.forEach(k => {
                for (var key in valor) {
                  if(key == k){
                    valor = valor[key];
                  }
                }

          });
          if(tipo_dato == 'datetime'){
            valor = this.$options.filters.fechaCompleta(valor);
          }
          if(tipo_dato == 'boolean'){
            valor = ((valor == 'true') || (valor == true)) ? true : false;
          }
          return valor;
        },
        cargar(col){
          this.page = 1;
          this.$emit('cargar',this.query);
        },
        async cargarOpciones(evento,columna,idx){
          let busqueda = evento.target.value;
          let ruta = `${this.base_url}${columna.url_busqueda}?${columna.texto_opcion}=${busqueda}&limit=9999999999`;
          //console.log(ruta,columna);
          if(busqueda == undefined || busqueda == ''){
            this.columnas[idx].busqueda = '';
            this.cargar();
          }else{
            await this.axios.get(ruta,this.headers).then((res)=>{
              this.columnas[idx].opciones = res.data.data.data;
            }).catch((e)=>{

            });
          }
          //console.log('cargar',evento.target.value);
          //console.log('busqueda: '+columna.busqueda);
        },
        emitir(item,evento,idx){
          this.$emit(evento,{item:item,idx:idx});
        },
        navegar($event){
          //console.log('page',this.page,$event)
          this.$emit('cargar',this.query);
        },
        ...mapMutations(['actualizarTablaPaginada'])
    },
    computed:{
        query(){
          let string = '?';
          let and = '';
          let total = this.columnas.length - 1;
          this.columnas.forEach((c,index) => {
            
            if(c.searchable && c.busqueda !== '' && c.tipo != 'evento'){
              if(index > 0 && string.length>0){
                and = '&';
              }else if(index == total){
                and = '';
              }
              string += `${and}${c.key}=${c.busqueda}`;
            }

          });
          string += `&limit=${this.paginacion}&page=${this.page}`;
          return string;
        },

        ...mapState(['lista','columnas','total_paginas','base_url','headers'])
    }
}
</script>
<style>
select{
  border: 1px solid #B0BEC5;
  border-radius: 0%;
  padding: 0px 20px;
  width: 100%;
}
input[type=date]{
  border: 1px solid #B0BEC5;
  border-radius: 0%;
  padding: 0px 20px;
  width: 100%;
}
input[type=number]{
  border: 1px solid #B0BEC5;
  border-radius: 0%;
  width: 100%;
}
</style>
